import gql from 'graphql-tag';

export default gql`
  fragment taskActionFragment on TaskAction {
    id
  }
`;
